<template>
<!--
  <div class="">
  <div class="tab__header">
    <a href="#" class="tab__link p-4 block bg-blue-dark hover:bg-blue-darker no-underline text-white border-b-2 border-white flex justify-between" @click.prevent="active = !active">
      <strong>{{title}}</strong>
      <span class="down-Arrow" v-show="!active">&#9660;</span>
      <span class="up-Arrow" v-show="active">&#9650;</span>
    </a>
  </div>
  <div class="tab__content p-2" v-show="active"><slot /></div>
</div>

-->
  <div>
  <md-card v-if="!noCard">
    <md-card-header class="md-card-header-icon">
      <h4 class="title" @click="active = !active">
        <md-icon>{{icon}}</md-icon>{{title}}
        <span class="down-Arrow" v-show="!active">&#9660;</span>
        <span class="up-Arrow" v-show="active">&#9650;</span>
      </h4>

    </md-card-header>
    <md-card-content v-show="active">
      <slot />
    </md-card-content>
  </md-card>
    <template v-else>
      <h4 class="title" @click="active = !active">
<!--        <md-icon>{{"message"}}</md-icon>{{title}}-->
        {{title}}
        <span class="down-Arrow" v-show="!active">&#9660;</span>
        <span class="up-Arrow" v-show="active">&#9650;</span>
      </h4>
      <md-content v-show="active"><slot /></md-content>

    </template>
  </div>

</template>

<script>
export default {
  name: "accordion",
  props: [
    'title',
    'icon',
    'noCard'
  ],
  data() {
    return {
      active: true,
    }
  },
  created() {
    this.$parent.accordions.push(this);
  }
}
</script>

<style lang="scss">
  .md-card-header-icon span {
    &.down-Arrow,
    &.up-Arrow {
      position: absolute;
      right: 0px;
      top: -6px;
    }
  }

  .md-card .md-card-header.md-card-header-icon .title {
    cursor: pointer;
    width: 100%;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

</style>